function cov_m4hjbvpjw() {
  var path = "/app/src/utils/check-price.tsx";
  var hash = "bdcdb7403eb44db9f7bf3a232a299cdd823a38de";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/utils/check-price.tsx",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 26
        },
        end: {
          line: 6,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "bdcdb7403eb44db9f7bf3a232a299cdd823a38de"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_m4hjbvpjw = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_m4hjbvpjw();
import { createNormalizeCheckingNumber } from 'src/utils/create-normalize-checking-number';
export var checkPrice = (cov_m4hjbvpjw().s[0]++, createNormalizeCheckingNumber("Price argument is not a number. Tabby widget will be use a default price value ".concat(100), 100));